module.exports = __webpack_public_path__ + "img/responsive.50f2f233.jpg";